import { MarketHourCloseIndicator } from '@ui/features/RWA/components/MarketHourCloseIndicator';
import { HstackProps } from 'styled-system/jsx';

import { useOrderListContext } from './context';

export const OrderMarketCloseIndicator = (p: HstackProps) => {
  const { isMarketHourOpen } = useOrderListContext();
  if (isMarketHourOpen) return;

  return <MarketHourCloseIndicator isOrder {...p} />;
};
